<template>
  <div class="about">
    <h1>Logout</h1>
  </div>
</template>
<script>
export default {
	name: 'Logout',
	components: {
	},
	mounted(){
		this.logout();
	},
	data() {
		return{
			email: '',
			password: '',
			error_msg: '',
		};
	},
	methods: {
		logout(){
			this.$session.destroy()
			this.$router.push('/')
		}
	}
}
</script>